module.exports = __webpack_public_path__ + "img/足球.f2216c45.jpg";